import { MenuItem } from "@mui/material";
import { baseURLWithoutPort } from "../api/GardenoApi";

export const convertToLanguage = (language) => {
  if (language === "GB") {
    return "EN";
  } else if (language === "EN") {
    return "GB";
  } else {
    return language;
  }
};
export const getMenuItems = (array) => {
  return array?.map((item) => (
    <MenuItem key={item} value={item}>
      {item}
    </MenuItem>
  ));
};
export const onChangeHandler = (event, setState) => {
  setState(event.target.value);
};

export function getTimeRange(start, end, step) {
  const startTime = new Date(`2000-01-01T${start}`);
  const endTime = new Date(`2000-01-02T${end}`);

  const stepMilliseconds = parseFloat(step) * 60 * 60 * 1000; // Convert step to milliseconds

  const times = [];
  let currentTime = startTime;

  while (currentTime <= endTime) {
    times.push(formatTime(currentTime));
    currentTime = new Date(currentTime.getTime() + stepMilliseconds);
  }

  return times;
}

function formatTime(date) {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}
export function dateWithoutTime(date) {
  const parts = date.split("T");
  if (parts.length === 2) {
    const dateParts = parts[0].split("-");
    if (dateParts.length === 3) {
      const year = dateParts[0];
      const month = dateParts[1];
      const day = dateParts[2];
      return `${day}-${month}-${year}`;
    }
  }
  // Handle invalid input
  return null;
}

export function calculateCost(start, end, ratePerDay) {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const backOffTime = 3;
  let days;
  const timeDifference = endDate - startDate;

  // Convert milliseconds to days
  const hours = timeDifference / (1000 * 60 * 60);

  if (hours <= 24 + backOffTime) {
    days = 1;
  } else if (hours % 24 <= 3) {
    days = hours / 24;
  } else {
    days = hours / 24 + 1;
  }
  return ratePerDay * parseInt(days);
}

export function findObgjectInArray(array, attribute, value) {
  const foundElement = array?.find((element) => element[attribute] === value);
  return foundElement;
}
export const getImgUrl = (url) => {
  return `${baseURLWithoutPort}${url}`;
};
export const addEuro = (price) => {
  return price + " €";
};
export const isEmail = (email) => {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};
export const isPhone = (phone) => {
  return /^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/.test(
    phone
  );
};
export const changeObgjectValueInArrayState = (
  state,
  setState,
  attributeToChange,
  newValue,
  attributeToIdentify,
  valueToidentify
) => {
  let tempArray = state?.slice();
  tempArray?.forEach((element, index) => {
    if (element[attributeToIdentify] === valueToidentify) {
      tempArray[index][attributeToChange] = newValue;
    }
  });
  setState(tempArray);
};
